import { createContainer } from 'react-sweet-state';

import { GenerationStore, PRIVATE_ACTIONS } from './GenerationStore';

export const GenerationStoreContainer = createContainer(GenerationStore, {
  onInit:
    () =>
    ({ setState, dispatch }, { state }) => {
      dispatch(PRIVATE_ACTIONS.init());

      if (state) {
        setState(state);
      }
    },
  onUpdate:
    () =>
    ({ setState }, { state }) => {
      if (state) {
        setState(state);
      }
    },
});
